export class SubtitleParserVtt {
}
